<template>
  <v-app>
    <v-main>
      <sidebar v-if="viewSidebar()"/>
      <router-view :key="$route.fullPath" />
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from "./components/Sidebar.vue";
import { mapActions  } from "vuex";
export default {
  components: { Sidebar },
  name: "App",

  data: () => ({}),
  methods: {
    ...mapActions(["readToken", "validateLicense"]),
    viewSidebar(){
      //  console.log(this.$route.meta.requireAuth);
      return localStorage.getItem('token') && this.$route.meta.requireAuth ? true : false
    }
  },
  
  created() {
    this.readToken();
  },
  updated() {
    let name = this.$utilFront.getNameBranchOffice();
    if (this.$utilFront.isEmpty(name)) {
      document.title = "SUIM";
    } else {
      document.title = "SUIM | " + name;
    }
     this.validateLicense();
  }
};
</script>
<style>
.theme--light.v-application {
  background-color: #f9f9f9 !important;
}
</style>